import storageWithExpiration from '@ott/storage-with-expiration';
import getValidParams from './getValidParams';
import defaultInitialValues from './defaultInitialValues';

import get from 'lodash/get';
import isObject from 'lodash/isObject';

import startOfDay from 'date-fns/startOfDay';
import format from 'date-fns/format';

const DAY_LENGTH = 1000 * 60 * 60 * 24;
const WEEK_LENGTH = 1000 * 60 * 60 * 24 * 7;
const SEARCH_KEY = 'OTT/tours/lastSearch/v1.0';

const stringifyParams = (rawParams) => {
  const params = { ...rawParams };

  if (isObject(params.dates)) {
    const { startDate, endDate } = params.dates;

    params.dates = {
      startDate: startDate ? format(startDate, 'yyyy-MM-dd') : startDate,
      endDate: endDate ? format(endDate, 'yyyy-MM-dd') : endDate,
    };
  }

  return params;
};

const prepareParams = (rawParams) => {
  const params = { ...rawParams };

  if (isObject(params.dates)) {
    const { startDate, endDate } = params.dates;

    params.dates = {
      startDate: startDate ? startOfDay(startDate) : startDate,
      endDate: endDate ? startOfDay(endDate) : endDate,
    };
  }

  return params;
};

export default {
  set(searchParams = {}) {
    const preparedParams = stringifyParams(searchParams);

    const startDateStr = get(searchParams, 'dates.startDate');
    const expires = startDateStr
      ? new Date(startDateStr).getTime() - Date.now() - 2 * DAY_LENGTH
      : WEEK_LENGTH;

    storageWithExpiration.set(SEARCH_KEY, preparedParams, expires);
  },

  get({ minDate, maxDate }) {
    const storedSearchParams = storageWithExpiration.get(SEARCH_KEY);
    const preparedParams = prepareParams(storedSearchParams);

    return {
      ...defaultInitialValues,
      ...getValidParams(preparedParams, { minDate, maxDate }),
    };
  },
};
